import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';
import { dispatchModalContextSubmissionSuccessful } from 'Hooks/useRefreshEvent';
import Sentry from 'Integrations/Sentry';

const useStyles = buildUseStyles('ModalForm', (() => ({
  root: {},
  rootLimited: {
    height: '100%',
  },
  title: {
    width: '100%',
  },
  actions: {
    width: '100%',
  },
  dialogPaper: {
    width: '100%',
  },
  formsLimitedHeight: {
    height: '100%',
  },
  metaFormInline: {
    display: 'flex',
    flexDirection: 'column',
  },
  metaFormInlineLimited: {
    height: '100%',
  },
  errorList: {
    alignSelf: 'center',
    maxWidth: '80%',
  },
  errorListMobile: {},
})));

/**
 * @deprecated use Views/Page/Content/Modal/Components/ModalForm2 instead
 */
const ModalForm = ({
  Layout,
  limitedMaxHeight,
  onlyRenderLayout,
  metaOverrideSet,
}) => {
  const classes = useStyles();
  const {
    modalCollection,
    setModalCollection,
  } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();
  const { handleInterceptResponse } = useIdentityChallengeContext();
  const isMobile = useMobileLayout();
  if (!modalCollection) {
    return null;
  }

  return (
    <MetaCollectionFormInline
      collection={modalCollection}
      key={modalCollection.link('self').url()}
      metaOverrideSet={metaOverrideSet}
      margin={'none'}
      padding={'none'}
      classes={{
        root: classNames(classes.root, {
          [classes.rootLimited]: limitedMaxHeight,
        }),
        forms: classNames({
          [classes.formsLimitedHeight]: limitedMaxHeight,
        }),
      }}
      FormProps={{
        className: classNames(classes.metaFormInline, {
          [classes.metaFormInlineLimited]: limitedMaxHeight,
        }),
        layout: Layout,
        noIndividualSubmitButtons: true,
        onSubmit: async (possiblyDicrsResponse, argsOrIndex, args) => {
          return handleInterceptResponse(possiblyDicrsResponse, (originalRequestResponse) => {
            try {
              setModalCollection(originalRequestResponse);
            } catch (err) {
              Sentry.createSentryErrorLog(err);
              throw err;
            }
            dispatchModalContextSubmissionSuccessful(
              originalRequestResponse,
              // Once upon a time, long long ago, someone made it so that some metaforms will have an index as their second argument in onSubmit and others will not have an index.
              // TODO: stop the madness one day with a new rendition of metaforms
              typeof argsOrIndex === 'number' ? args : argsOrIndex,
            );
            return originalRequestResponse;
          },
          (err) => {
            displayErrorMessage(err, err.errors);
          });
        },
        LayoutProps: {
          onlyRenderLayout,
          errorListClassName: isMobile ? classes.errorListMobile : classes.errorList,
        },
      }}
    />
  );
};

ModalForm.defaultProps = {
  limitedMaxHeight: false,
  onlyRenderLayout: false,
};

ModalForm.propTypes = {
  metaOverrideSet: PropTypes.object.isRequired,
  limitedMaxHeight: PropTypes.bool,
  onlyRenderLayout: PropTypes.bool,
  Layout: PropTypes.object.isRequired,
};

export default ModalForm;
